const template = String.raw`
{% case languageId -%}
{% when '1' -%}
    {% assign timerSettings = "Ustawienia licznika" -%}
    {% assign chooseTimerEndDate = "Wybierz końcową datę do odliczania" -%}
{% else -%}
    {% assign timerSettings = "Timer settings" -%}
    {% assign chooseTimerEndDate =  "Choose the end date for the countdown" -%}
{% endcase -%}

<div id="bannerSettings">
    <fieldset class="bannerSettings__fieldset" name="bannerSettings__timer">
        <legend class="bannerSettings__legend">{{timerSettings}}</legend>
        <label class="bannerSettings__label" for="timerDateTo">{{chooseTimerEndDate}}</label>
        <input class="bannerSettings__input" type="datetime-local" name="timerDateTo" data-timer-utc="{{settings.timerDateTo}}" step="1"/>
    </fieldset>
</div>
<script type="text/javascript">
    var bannerSettings;
    var timerDateTo;
    var maxDays = 90;

    function utcToLocalISO(utcDateTime) {
        var timezoneOffset = (new Date()).getTimezoneOffset() * 60000;
        return (new Date(utcDateTime - timezoneOffset)).toISOString();
    }

    function setInitalValue() {
        var utcDateTimeString = timerDateTo.getAttribute('data-timer-utc');
        if (!utcDateTimeString) {
            return;
        }
        var utcDateTime = new Date(utcDateTimeString);
        if (isNaN(utcDateTime.getTime())) {
            console.error('Invalid date string:', utcDateTimeString);
            return;
        }
        var localISODateTime = utcToLocalISO(utcDateTime);
        timerDateTo.value = localISODateTime.slice(0, 19);
    }

    function setMin() {
        var now = new Date();
        var localNowISO = utcToLocalISO(now);
        timerDateTo.min = localNowISO.slice(0, 19);
    }

    function setMax() {
        var max = new Date();
        max.setDate(max.getDate() + maxDays);
        var localMaxISO = utcToLocalISO(max);
        timerDateTo.max = localMaxISO.slice(0, 19);
    }

    function validateSettings() {
        if (timerDateTo) {
            var localISODateTime = timerDateTo.value;
            if (!localISODateTime) {
                return true;
            }
            var localDateTime = new Date(localISODateTime);
            if (isNaN(localDateTime.getTime())) {
                return false;
            }
            var now = new Date();
            if (localDateTime < now) {
                return false;
            }
            var max = new Date();
            max.setDate(max.getDate() + maxDays);
            if (localDateTime > max) {
                return false;
            }
        }
        return true;
    }

    function getFormData() {
        var data = {};
        if (timerDateTo) {
            var localDateTime = timerDateTo.value;
            if (localDateTime) {
                var utcDateTime = new Date(localDateTime).toISOString();
                data.timerDateTo = utcDateTime;
            } else {
                data.timerDateTo = '';
            }
        }
        return data;
    }

    function init() {
        bannerSettings = document.getElementById('bannerSettings');

        if (!bannerSettings) {
            return;
        }
        timerDateTo = bannerSettings.querySelector('[name="timerDateTo"]');
        if (timerDateTo) {
            setInitalValue();
            setMin();
            setMax();
        }
    }

    init();

    function __saveBannerDetailsSettings() {
        return getFormData();
    }

    function __validateBannerDetailsSettings(value) {
        return validateSettings();
    }
</script>
<style>
    #bannerSettings .bannerSettings__fieldset {
        width: 33.33%;
        padding: 20px;
        display: flex;
        flex-direction: column;
        border: 1px solid #ccc;
        box-shadow: 0 1px 4px 0 rgba(65, 64, 65, .26);
    }

    #bannerSettings .bannerSettings__legend {
        font-size: 1.2em;
    }

    #bannerSettings .bannerSettings__label {
        margin-bottom: 10px;
    }

    #bannerSettings .bannerSettings__input {
        border: 1px solid #ccc;
        box-sizing: border-box;
        border-radius: 0;
        padding: 10px;
        transition: border-color 0.3s ease;
        box-shadow: 0 1px 4px 0 rgba(65, 64, 65, .26);
    }

    #bannerSettings .bannerSettings__input:user-invalid {
        border-color: red;
    }

    #bannerSettings .bannerSettings__input:user-valid {
        border-color: green;
    }
</style>
`

export default template;